<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" overflow="visible">
  <circle class="primary-stroke" cx="25" cy="25" r="20" fill="none" stroke="#ffffff" stroke-width="3"/>
</svg>
